export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-3 whitespace-nowrap">
            <i className="ri-information-line"></i>平台介绍
          </span>
          <h2 className="font-heading text-[28px] md:text-4xl text-foreground-950 mb-6">关于 51影院</h2>
          <div className="text-left bg-background-100 rounded-xl p-6 md:p-10">
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
              51影院是一个专业的全网影视资源聚合平台，致力于为影视爱好者提供一站式的在线观影服务。我们汇聚了奇优影院、97影院、窝窝影院、第九影院等多家热门站点的高清影视资源，覆盖最新电影、热播电视剧、热门综艺、人气动漫等全品类内容。
            </p>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
              平台采用智能资源调度与高速CDN加速技术，确保所有影片高清流畅播放，真正做到了即点即看、无需等待。我们的内容团队每日同步全网最新上线资源，第一时间将最新的影视内容呈现给用户，让你永远走在追剧第一线。
            </p>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
              从热血动作到烧脑悬疑，从爆笑喜剧到高分纪录，51影院以丰富的内容类型和极致的观影体验，成为越来越多影视爱好者的首选平台。无论你是电影发烧友、追剧达人还是综艺控，这里都是你的专属私人影院。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}